import React, { useMemo } from "react"
import { useHistory } from "react-router-dom"

import modStyl from './index.module.scss'
import storageX from "../../../utils/storageX"
import avatar from "../../assets/images/man.jpg"
import LazyIcon from "../lazy-icon"

type IntroProps = {
  mode: 0 | 1
}
const Intro: React.FC<IntroProps> = ({ mode })=> {
  if (mode === 0) {
    return (
      <p>
        <span>管理患者：</span>
        <span>12位</span>
      </p>
    )
  }
  return (
    <ul>
      <li>肿瘤科</li>
      <li>上海第六人民医院</li>
    </ul>
  )
}

//////////////////////////////////////////////////////////

type Props = {
  mode?: 0 | 1
  gender?: 0 | 1
}


const UserInfo: React.FC<Props> = ({ gender = 0, mode = 0 })=> {
  const user = useMemo(()=> storageX().user(), [])

  const his = useHistory()

  const n2profile = ()=> {
    if (mode === 0) {
      his.push('/v2/profile')
    }
  }

  return (
    <div className={modStyl.wrapper}>
      <div onClick={n2profile} className={modStyl.west}>
        <img src={avatar} />
      </div>
      <div onClick={n2profile} className={modStyl.middle}>
        <h2>{user.userName}</h2>
        <Intro mode={mode} />
      </div>
      {mode === 0 && (
        <div className={modStyl.east}>
          <button onClick={()=> his.push('/v2/invitation')} type="button">
            <LazyIcon name="qr"/>
            <span>邀请患者</span>
          </button>
        </div>
      )}
    </div>
  );
}

export default UserInfo